import './EvlilikGelismeForm.css'
import { Button, Label, Input, Spinner } from 'reactstrap'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import WarningModal from './WarningModal'
import Header from '../../Header'
import Loading from '../../Loading'
import ConditionsCheckBox from './ConditionsCheckBox'
import axios from 'axios'

const EvlilikGelismeForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [wifeName, setWifeName] = useState('')
  const [wifeSurname, setWifeSurname] = useState('')
  const [wifeBirthDate, setWifeBirthDate] = useState('')
  const [wifeTcNo, setWifeTcNo] = useState('')

  const [husbandName, setHusbandName] = useState('')
  const [husbandSurname, setHusbandSurname] = useState('')
  const [husbandBirthDate, setHusbandBirthDate] = useState('')
  const [husbandTcNo, setHusbandTcNo] = useState('')

  const [contactAddress, setContactAddress] = useState('')
  const [contactPhone, setContactPhone] = useState('')

  const [applicantType, setApplicantType] = useState('wife')
  const [checkbox, setCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isModal, setIsModal] = useState({ title: '', message: '', type: '', active: false })

  const toggleWarningModal = (e) => {
    if (e?.stopPropagation) e.stopPropagation()
    setIsModal((prev) => ({
      ...prev,
      active: !prev.active,
    }))
  }

  const calculateAge = (birthDate) => {
    if (!birthDate) return null

    const today = new Date()
    const birth = new Date(birthDate)

    let age = today.getFullYear() - birth.getFullYear()
    const monthDiff = today.getMonth() - birth.getMonth()

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--
    }

    return age
  }

  const isValidPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '')
    return cleaned.length === 10 || cleaned.length === 11
  }

  const isFilledPerson = ({ name, surname, birthDate, tcNo }) => {
    return name.trim().length >= 2 && surname.trim().length >= 2 && !!birthDate
  }

  const isContactValid = () => {
    return contactAddress.trim().length >= 5 && isValidPhone(contactPhone)
  }

  const validateAgeRule = () => {
    const wifeAge = calculateAge(wifeBirthDate)
    const husbandAge = calculateAge(husbandBirthDate)

    if (wifeAge === null || husbandAge === null) return false

    if (wifeAge >= 41) return false
    if (husbandAge >= 41) return false

    return true
  }

  const onFinish = async (event) => {
    setLoading(true)

    const wifeValid = isFilledPerson({
      name: wifeName,
      surname: wifeSurname,
      birthDate: wifeBirthDate,
      tcNo: wifeTcNo,
    })

    const husbandValid = isFilledPerson({
      name: husbandName,
      surname: husbandSurname,
      birthDate: husbandBirthDate,
      tcNo: husbandTcNo,
    })

    if (!wifeValid || !husbandValid || !isContactValid()) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'server_error',
        title: 'Sunucu Hatası',
        message: 'Lütfen tüm alanları eksiksiz ve doğru şekilde doldurunuz.',
        active: true,
      }))
      return
    }

    // if (!validateAgeRule()) {
    //   setLoading(false)
    //   setIsModal((prevState) => ({
    //     ...prevState,
    //     type: 'server_error',
    //     title: 'Yaş Şartı Uygun Değil',
    //     message: 'Her iki eş de 41 yaş ve üzeri ise başvuru kabul edilmez.',
    //     active: true,
    //   }))
    //   return
    // }

    if (!checkbox) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'failed_agreement',
        active: true,
      }))
      return
    }

    event.currentTarget.disabled = true

    const payload = {
      id: state?.basvuruId,
      applicant_type: applicantType,
      wife: {
        name: wifeName,
        surname: wifeSurname,
        birth_date: wifeBirthDate,
        tc_no: wifeTcNo,
      },
      husband: {
        name: husbandName,
        surname: husbandSurname,
        birth_date: husbandBirthDate,
        tc_no: husbandTcNo,
      },
      contact: {
        address: contactAddress,
        phone: contactPhone,
      },
      contract_approved: checkbox,
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/evlilik-gelisme-create`, payload, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token')),
        },
      })

      if (res?.data?.code === 200) {
        navigate('/success-applications', {
          state: { id: res?.data?.result },
        })
      } else {
        setIsModal((prevState) => ({
          ...prevState,
          type: 'server_error',
          title: res?.data?.title || null,
          message: res?.data?.message || 'Bir hata oluştu.',
          active: true,
        }))
      }
    } catch (error) {
      setIsModal((prevState) => ({
        ...prevState,
        type: 'server_error',
        title: error.response?.data?.title || 'Sunucu Hatası',
        message: error.response?.data?.message || 'Bir hata oluştu',
        active: true,
      }))
    } finally {
      setLoading(false)
    }
  }

  const inputStyle = {
    width: '90vw',
    borderRadius: '20px',
  }

  const labelStyle = {
    paddingLeft: '1.4rem',
    color: '#285843',
    fontWeight: 'bold',
    fontSize: '0.9rem',
  }

  const personSections =
    applicantType === 'husband'
      ? [
          {
            key: 'husband',
            title: 'Erkek Eş Bilgileri',
            name: husbandName,
            setName: setHusbandName,
            surname: husbandSurname,
            setSurname: setHusbandSurname,
            birthDate: husbandBirthDate,
            setBirthDate: setHusbandBirthDate,
            tcNo: husbandTcNo,
            setTcNo: setHusbandTcNo,
          },
          {
            key: 'wife',
            title: 'Kadın Eş Bilgileri',
            name: wifeName,
            setName: setWifeName,
            surname: wifeSurname,
            setSurname: setWifeSurname,
            birthDate: wifeBirthDate,
            setBirthDate: setWifeBirthDate,
            tcNo: wifeTcNo,
            setTcNo: setWifeTcNo,
          },
        ]
      : [
          {
            key: 'wife',
            title: 'Kadın Eş Bilgileri',
            name: wifeName,
            setName: setWifeName,
            surname: wifeSurname,
            setSurname: setWifeSurname,
            birthDate: wifeBirthDate,
            setBirthDate: setWifeBirthDate,
            tcNo: wifeTcNo,
            setTcNo: setWifeTcNo,
          },
          {
            key: 'husband',
            title: 'Erkek Eş Bilgileri',
            name: husbandName,
            setName: setHusbandName,
            surname: husbandSurname,
            setSurname: setHusbandSurname,
            birthDate: husbandBirthDate,
            setBirthDate: setHusbandBirthDate,
            tcNo: husbandTcNo,
            setTcNo: setHusbandTcNo,
          },
        ]

  return (
    <>
      {loading ? (
        <Loading formText={'Başvurunuz alınıyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} />
      ) : (
        <div className='hide-scrollbar'>
          <div
            style={{
              backgroundColor: '#fff',
              position: 'sticky',
              top: 0,
            }}
          >
            <Header onClick={() => navigate(-1)} />
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + state?.basvuru_fotografi} alt='' width={'90%'} style={{ borderRadius: '10px' }} />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1rem',
              marginBottom: '0.5rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingBottom: '0.5rem',
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: '#285843',
            }}
          >
            {state?.basvuru_aciklamasi}
          </div>

          <Label style={labelStyle}>Başvuruyu Kim Yapıyor?</Label>
          <Input style={inputStyle} className='inputStyle' type='select' value={applicantType} onChange={(e) => setApplicantType(e.target.value)}>
            <option value='wife'>Kadın eş başvuru yapıyor</option>
            <option value='husband'>Erkek eş başvuru yapıyor</option>
          </Input>

          {personSections.map((person) => (
            <React.Fragment key={person.key}>
              <div style={{ ...labelStyle, marginTop: '1rem' }}>{person.title}</div>

              <Label style={labelStyle}>İsim</Label>
              <Input style={inputStyle} className='inputStyle' value={person.name} onChange={(e) => person.setName(e.target.value)} />

              <Label style={labelStyle}>Soyisim</Label>
              <Input style={inputStyle} className='inputStyle' value={person.surname} onChange={(e) => person.setSurname(e.target.value)} />

              <Label style={labelStyle}>Doğum Tarihi</Label>
              <Input style={inputStyle} className='inputStyle' type='date' value={person.birthDate} onChange={(e) => person.setBirthDate(e.target.value)} />

              <Label style={labelStyle}>T.C. Kimlik No</Label>
              <Input style={inputStyle} className='inputStyle' value={person.tcNo} maxLength={11} onChange={(e) => person.setTcNo(e.target.value.replace(/\D/g, ''))} />
            </React.Fragment>
          ))}

          <div style={{ ...labelStyle, marginTop: '1rem' }}>İletişim Bilgileri</div>

          <Label style={labelStyle}>Adres</Label>
          <Input style={inputStyle} className='inputStyle' type='textarea' value={contactAddress} onChange={(e) => setContactAddress(e.target.value)} />

          <Label style={labelStyle}>Telefon</Label>
          <Input style={inputStyle} className='inputStyle' value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} />

          <div className='ms-4 mt-3'>
            <ConditionsCheckBox checkbox={checkbox} setCheckbox={setCheckbox} basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama} kisa_metin='Yanıbaşımda Karatay Eğitim Yardımı Sözleşmesi, Evlilik ve Aile Gelişim Akademisi Şartnamesi, Kullanım Koşulları ve KVKK metnini okudum ve kabul ettim.' />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1rem',
              marginBottom: '2rem',
            }}
          >
            <Button
              block
              onClick={onFinish}
              style={{
                marginLeft: '1rem',
                marginRight: '1rem',
                backgroundColor: '#285843',
              }}
            >
              {loading ? <Spinner size={'sm'} /> : 'Başvuruyu Tamamla'}
            </Button>
          </div>
        </div>
      )}

      <WarningModal isModal={isModal.active} checkbox={checkbox} messageType={isModal.type} messageTitle={isModal?.title} errorMessage={isModal?.message} toggleWarningModal={toggleWarningModal} />
    </>
  )
}

export default EvlilikGelismeForm
